module.exports = __webpack_public_path__ + "img/machineThre-img3.89219de6.jpg";